export enum VIEW {
  CIP_GENERATION = '/generarcip',
  SERVICES = '/servicios',
  CIP_REPORT = '/reportecip',
  USERS = '/usuarios',
  HOME = '/',
  CREATE_USER = '/usuarios/crear'
}
